import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';
import { PackageService } from '../services/package.service';
import { UserService } from '../services/user.service';
import { AppointmentService } from '../services/appointment.service';
import { TranslatePipe } from '../pipes/translate.pipe';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-package-details',
  templateUrl: './my-package-details.component.html',
  styleUrls: ['./my-package-details.component.scss'],
  providers: [TranslatePipe]
})
export class MyPackageDetailsComponent {
  @Input() selectedPackage: any;
  @Output() close = new EventEmitter<boolean>();
  @Output() next: EventEmitter<any>;
  @Output() cancelPackage = new EventEmitter<any>();
  public applicableServices
  public groupedServices
  public readonly footerApplicableStatus = ['A', 'C']
  packageDetails: any;
  public selectedPackageDtls: any;
  isMobileView = false;
  mobileScreen = 1;

  purchasedForName = '';
  modeOfServiceLabel = '';
  public showPkgAccord: boolean = false;
  public showPaymentDtlAccord: boolean = false;
  public showInclServAccord: boolean = false;
  public showServiceIncludedModal: boolean = false;
  public selectedGrpService: any;
  public openConsultationTypeSelection: boolean = false;
  public bookSubsequentAppt: any;
  public options: any;
  public openHealthPkgs: boolean = false;
  public modeOfService: any;
  private consultResolve!: (value: string | null) => void;
  public subserviceWithResource: any;
  public isMultiplePractCode: boolean = false;
  constructor(
    private packageService: PackageService,
    private user: UserService,
    private apptService: AppointmentService,
    private translatePipe: TranslatePipe,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.updateMobileView();
    this.initializeComputedFields();
    this.fetchPackageDetails(this.selectedPackage);
  }

  @HostListener('window:resize')
  updateMobileView(): void {
    this.isMobileView = window.innerWidth <= 780;
  }

  initializeComputedFields(): void {
    const pkg = this.selectedPackage || {};

    this.purchasedForName =
      pkg.patientName ||
      pkg.patientNm ||
      pkg.patient?.fullName ||
      pkg.patient?.name ||
      '';

    this.modeOfServiceLabel = pkg.modeOfService || pkg.serviceMode || pkg.channel || 'Clinic';
  }

  fetchPackageDetails(pkg): void {
    if (!pkg) return;

    const params = {
      patientId: pkg.patientId,
      facilityId: pkg.facilityId,
      package: [
        {
          packageCode: pkg.packageCode,
          packageSeq: pkg.subscriptionId,
          appointmentId: pkg.appointment_id,
          orderSetId: pkg.orderSetId
        }
      ]
    };

    this.packageService.getPackageDetail(params).subscribe((data: any) => {
      if(data.packageServDtls && data.packageServDtls.length>0){
        pkg['pkgList']=data.packageServDtls && data.packageServDtls.map((p)=>{
          p['desc']=p['serviceDesc'];
          return {desc:p['serviceDesc']};
        })
        pkg['serviceIncluded'] = data.packageServDtls
        pkg.groupedServices = this.groupServices(pkg, data.packageServDtls);
      }
      this.showPkgAccord = false;
      this.showInclServAccord = false;
      this.showInclServAccord = false;
      this.selectedPackageDtls = pkg;
      setTimeout(() => {
        this.setPercentForIndPkg(pkg);
      }, 500)
      if (data?.packageServDtls?.length) {
        data.packageServDtls.forEach((p: any) => (p.desc = p.serviceDesc));
        this.packageDetails = { serviceIncluded: data.packageServDtls };
      }
      this.applicableServices = this.selectedPackageDtls.serviceIncluded;
      this.groupedServices = this.selectedPackageDtls.groupedServices;
      // console.log('selectedPackage', this.selectedPackageDtls, 'packageDetails', this.packageDetails);
    });
  }

    public setPercentForIndPkg(pkg) {
    let progressCnt = document.getElementById("progress-container")
    if (!progressCnt) return
    let x = progressCnt.getAttribute("data-percentage");
    let progressEle = document.getElementById("progress");
    if (!progressEle) return;
    if(pkg.status=='Cancelled' || pkg.status=='Completed')
      progressEle.style.width = x ? x : '100' + '%'
    else 
      progressEle.style.width = x ? x : pkg.completedPercent + '%'
  } 

  private groupServices(selectedPkg, services) {
    let includedServices = selectedPkg._healthPackage?.packageDtls?.servicesApplicable;
    if(!includedServices) return []
    let groupedServices = this.apptService.groupServices(includedServices, services, selectedPkg)
    return groupedServices
  }

  goToServiceDetails(): void {
    this.mobileScreen = 2;
  }

  onBack(): void {
    if (this.isMobileView && this.mobileScreen === 2) {
      this.mobileScreen = 1;
      return;
    }
    this.close.emit(false);
  }

  closeModal(): void {
    this.close.emit(true);
  }

  onCancelPackage(): void {
    this.cancelPackage.emit(this.selectedPackage);
  }

  getPackageContent(detail: any[]): string {
    if (!detail?.length) return '';
    const lang = this.user.currentLanguage;
    const match = detail.find((d) => d.locale === lang);
    return match?.packageContent || detail[0]?.packageContent || '';
  }

  public async showIncludedServices(services) {
    this.showServiceIncludedModal = true;
    this.selectedGrpService = services;
  }

  public closeServiceModal() {
    this.showServiceIncludedModal = false;
  }

  public openAppointmentDetails(groupedService) {
    // console.log('openAppointmentDetails', this.selectedPackage, groupedService);
    this.user.setAppointmentRefNum(this.selectedPackage['appointment_id']);
    this.close.emit(true);
  }


  public async bookSubservice(firstService, service, grpService) {
    this.user?.setIsBookingSubService(true);
    // console.log('bookSubservice', firstService, 'groupedService pkg', service, 'groupedService', grpService, 'selectedPackage', this.selectedPackage);
    try {
      let groupedService = grpService
      let includedPackages = this.selectedPackage.serviceIncluded
      let selectedPackage = this.selectedPackage.packageInfo
      let modeOfService = this.selectedPackage.modeOfService === 'CLINIC' ? 'CLINIC' : 'HOMECARE';
      let { concept, applicableFacilities } = this.user.getGroupedConcepts(groupedService.includedServices[0], includedPackages)
      let facility = applicableFacilities.find(fac => fac.facilityId === this.selectedPackage.facilityId)
      let patient = this.user.getPatientByPatientId(this.selectedPackage.patientId, null)
      let careElementType = concept?.[0]?.careElementType
      // console.log('facility', facility, 'patient', patient, 'careElementType', careElementType);
      let defaultConsultationType = modeOfService === 'CLINIC' ? 'HOSPITAL' : 'VIDEO';
      let keyNameForConsultationType = modeOfService === 'CLINIC' ? 'clinicConsultTypecode' : 'homecareConsultTypecode';
      let consultationType = ['HOSPITAL', 'VIDEO', "ALL"].includes(groupedService.includedServices[0][keyNameForConsultationType]) ? groupedService.includedServices[0][keyNameForConsultationType] : defaultConsultationType;
      if (consultationType === 'ALL' && concept[0]?.careElementType === 'CON') {
        consultationType = await this.getConsultationType()
        if (!consultationType) return;
      }
       let careElementParams = {
          careElementType: careElementType,
          consultationType: consultationType
        }
      this.packageService.setValue('flowType', 'HEALTHPKG');
      this.packageService.setValue('selectedPackage', this.selectedPackage?._healthPackage);
      this.packageService.setValue('selectedVisitType', this.selectedPackage?.modeOfService);
      this.packageService.setValue('packageIndicator', this.selectedPackage?._healthPackage?.packageDtls?.pacakgeIndicator);
      this.packageService.setValue('classification', this.selectedPackage?._healthPackage?.packageDtls?.packageClassification);
      this.packageService.setValue('isHealthPackage', true);
      this.packageService.setValue('bookingForConcepts', concept);
      this.packageService.setValue('choosenFacility', facility);
      this.packageService.setValue('selectedFacilityEvent', facility);
      this.packageService.setValue('selectedDirective', this.selectedPackage?._healthPackage?._directiveRef);
      this.packageService.setValue('selectedFacilityId', this.selectedPackage.facilityId);
      this.packageService.setValue('selectedPatient', patient);
      this.packageService.setValue('selectedVisitType', modeOfService === 'CLINIC' ? 'CLINIC' : 'HOMECARE');
      this.packageService.setValue('bookingApplicableFacilities', facility ? [facility] : []);
      this.packageService.setValue('subServicesForAppointmentBooking', groupedService.concepts);
      this.packageService.setValue('isBookingSubService', true);
      this.packageService.setValue('consultationType', consultationType);
      this.packageService.setValue('careElementType', careElementType);
      this.packageService.setValue('careElementParams', careElementParams);
      const state = {
        selectedDirective: this.selectedPackage?._healthPackage?._directiveRef,
        selectedPackage: selectedPackage,
        selectedFacilityId: this.selectedPackage.facilityId,
        choosenFacility: facility,
        selectedPatient: patient,
        bookingForConcepts: concept,
        selectedVisitType: modeOfService === 'CLINIC' ? 'CLINIC' : 'HOMECARE',
        packageIndicator: 'ORDERSET',
        bookingApplicableFacilities: facility ? [facility] : [],
        subServicesForAppointmentBooking: groupedService.concepts,
        isBookingSubService: true,
        careElementParams: {
          careElementType: careElementType,
          consultationType: consultationType
        }
      }
      if (concept[0]?.careElementType === 'CON') {
        this.modeOfService = 'CON';
        let applicableSpecialities = facility?.controls?.applicableSpecialities;
        let facilityId = facility?.facilityId;
        let facilityForConsultation = this.user.getFacilityByFacilityId(facilityId)
        let deeplink = { facility: facilityForConsultation, applicableSpecialities: applicableSpecialities }
        let options = {
          deeplink: deeplink,
          packageState: state
        }
        switch (consultationType) {
          case 'HOSPITAL':
            this.bookSubsequentAppt = 'HOSPITAL'
            this.options = options;
            this.openHealthPkgs = true;
            break;
          case 'VIDEO':
            this.bookSubsequentAppt = 'VIDEO'
            this.options = options;
            this.openHealthPkgs = true;
            break;
        }
      } else {
        this.modeOfService = 'CLINIC';
        let resources = state?.choosenFacility?.controls?.packageCalendarResourceCode;
        let resource = resources?.split(',') || []
        if(resource.length==1){
          state.choosenFacility.controls.packageCalendarResourceCode = resource[0];
          this.packageService.setValue('choosenFacility', state.choosenFacility);
          this.subserviceWithResource = {data: state.choosenFacility, state: 'CHOOSE_PATIENT', key: 'selectedFacility', isSubserviceWithOneresource: true};
          this.openHealthPkgs = true;
        }else if(resource.length>1){
          let allPractitioner = this.user.getAllPractitioners(false, true, ['HOSP', 'HOSPVIDEO']);
          let packageResource=resource.map((res,index)=>{
            let found=allPractitioner.find(pract => pract.resourceId == res)
            if(found){
              return found;
            }else{
              return {resourceId:res,index:index,showPractWithIdOnly:true,order:2}
            }
          })
        let packageResources = packageResource;
        this.packageService.setValue('packagePractResources', packageResources)
        const uniqueSpecialityIds = [...new Set(packageResource.map(p => p.specialityId))];

        if (state?.choosenFacility?.controls) {
            state.choosenFacility.controls.applicableSpecialities = uniqueSpecialityIds;
            this.packageService.setValue('choosenFacility', state.choosenFacility);
        }

        this.openHealthPkgs = true;
        this.isMultiplePractCode = true;
        }
      } 
      // else {
      //   let sanitizedPackage = JSON.parse(JSON.stringify(selectedPackage));
      //   let sanitizedState = JSON.parse(JSON.stringify(state));
      //   // let navigationExtras: NavigationExtras = {
      //   //   state: {
      //   //     selectedPackage: sanitizedPackage,
      //   //     from: 'PACKAGE',
      //   //     workflow: 'PACKAGE', // NEED TO MODIFY HERE
      //   //     navigationState: sanitizedState
      //   //   }
      //   // };
      //   // this.navCtrl.navigateForward('/home-care-service-location', navigationExtras);
      // }
    } catch (e) {
      
    };
  }

  public getConsultationType(): Promise<string | null> {
    this.openConsultationTypeSelection = true;

    return new Promise((resolve) => {
      this.consultResolve = resolve;
    });
  }

  public handleClose() {
    this.openConsultationTypeSelection = false;
    this.consultResolve?.(null);
  }

  public handleConfirm(consultType: string) {
    this.openConsultationTypeSelection = false;
    this.consultResolve?.(consultType);
  }

  public closeHealthPkg() {
    this.openHealthPkgs = false;
    this.user?.setIsBookingSubService(false);
    this.packageService.clearAllValues();
  }

  public redirectToMyPackage(event) {

  }

  translatedPkgObj(groupedService: any) {
  return this.translatePipe.transform(groupedService.includedServices[0], 'PACKAGEOBJ', null, null, groupedService?.firstService);
  }
}
